import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import { Grid } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

import "./style.css";

import { usePptos } from "../../../hooks/usePptos";
import { iniCreateBudgetDuplicate } from "../../../redux/actions/pptos";
import { Pptos } from "../../../models/pptos";
import { DialogConfirmDelete } from "../../modals/confirmDelete/DialogConfirmDelete";

export const Templates = ({ open, setOpen, createFrom, infoOpor = null }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { templates, initGetTemplates, initRemoveTemplates } = usePptos();

  const [openDialogConfirm, setOpenDialogConfirm] = useState(false);
  const [idSelected, setIdSelected] = useState(0);

  const createFromTemplate = async (templateId) => {
    const templateInfo = await Pptos.getDataTemplate(templateId);
    const budgetDetail = JSON.parse(templateInfo.detalle_plantilla);

    if (templateInfo.id) {
      const newData = {
        ...budgetDetail,
        referencia: templateInfo.nombre,
        template_mode: false,
        template_id: null,
        info_crm: infoOpor,
      };

      dispatch(iniCreateBudgetDuplicate(newData));
      navigate(`/ppto/0`);
    }
  };

  const handleOpenConfirm = async (id) => {
    setIdSelected(id);
    setOpenDialogConfirm(true);
  };

  const handleDelete = async () => {
    await initRemoveTemplates(idSelected);
    setOpenDialogConfirm(false);
  };

  const handleOpenModify = async (id) => {
    const templateInfo = await Pptos.getDataTemplate(id);
    const budgetDetail = JSON.parse(templateInfo.detalle_plantilla);

    if (templateInfo.id) {
      const newData = {
        ...budgetDetail,
        referencia: templateInfo.nombre,
        template_mode: true,
        template_id: id,
      };

      dispatch(iniCreateBudgetDuplicate(newData));
      navigate(`/ppto/0`);
    }
  };

  useEffect(() => {
    initGetTemplates();
  }, [initGetTemplates]);

  return (
    <div>
      {openDialogConfirm && (
        <DialogConfirmDelete
          open={openDialogConfirm}
          setOpen={setOpenDialogConfirm}
          params={{
            text_title: null,
            text_confirm: null,
            button_name: null,
            handleDelete,
          }}
        />
      )}

      <Dialog
        className="p-container-dialog-templatez"
        open={open}
        onClose={() => setOpen(false)}
        scroll={"paper"}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogTitle>
          Seleccionar plantilla
          <IconButton
            className="p-dialog-icon-close"
            aria-label="close"
            onClick={() => setOpen(false)}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers className="DialogContentVistaPrevia">
          <DialogBody
            templates={templates}
            createFromTemplate={createFromTemplate}
            handleOpenConfirm={handleOpenConfirm}
            handleOpenModify={handleOpenModify}
          />
        </DialogContent>

        <DialogActions className="DialogActionVistaPrevia">
          <Button
            className="p-btn-secondary p-btn-continue"
            variant="contained"
            size="medium"
            type="button"
            onClick={() => createFrom("cero")}
          >
            Crear desde cero
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

const DialogBody = ({
  templates,
  createFromTemplate,
  handleOpenConfirm,
  handleOpenModify,
}) => {
  return (
    <Grid
      container
      spacing="20"
      columnSpacing="40"
      alignItems="center"
      direction="row"
    >
      {templates?.map((it) => (
        <Grid item xs={12} sm={6} key={it.id}>
          <div className="p-box-items-templates">
            <label title={it.nombre} style={{ textTransform: "uppercase" }}>
              {it.nombre.length > 25
                ? `${it.nombre?.substring(0, 25)}...`
                : it.nombre}
            </label>
            <div className="d-flex justify-content-between align-items-center mt-2">
              <Button
                title="usar esta plantilla"
                type="button"
                className="btn btn-sm p-btn-primary-small"
                style={{ height: "50px" }}
                onClick={() => createFromTemplate(it.id)}
              >
                Usar
              </Button>
              <Button
                title="modificar plantilla"
                type="button"
                className="btn btn-sm p-btn-primary-small-nobg ms-2"
                onClick={() => handleOpenModify(it.id)}
              >
                Modificar
              </Button>
              <i
                className="bi bi-trash ms-5 p-trash"
                onClick={() => handleOpenConfirm(it.id)}
                title="eliminar plantilla"
              ></i>
            </div>
          </div>
        </Grid>
      ))}
    </Grid>
  );
};
